<app-nav [menuItems]="menuItems"></app-nav>
<app-version></app-version>
